import { TreeIcon } from './treeIcons'

/**
 * Zoom out, the current zoom (press for 1:1), zoom in, and Fit — fixed to the
 * frame, so they stay put however far the diagram moves. `Fit` is the way
 * back from a lost view, and on a phone it is the control that does most of
 * the work.
 */
export function ZoomControls({
  scale,
  zoomBy,
  fit,
}: {
  scale: number
  zoomBy: (factor: number) => void
  fit: () => void
}): JSX.Element {
  return (
    <div className="st-controls" role="toolbar" aria-label="Zoom">
      <button type="button" onClick={() => zoomBy(1 / 1.25)} aria-label="Zoom out">
        <TreeIcon name="minus" />
      </button>
      <button type="button" className="st-controls__pct" onClick={() => zoomBy(1 / scale)} aria-label="Zoom to 100%">
        {Math.round(scale * 100)}%
      </button>
      <button type="button" onClick={() => zoomBy(1.25)} aria-label="Zoom in">
        <TreeIcon name="plus" />
      </button>
      <button type="button" onClick={fit} aria-label="Fit everything in view">
        <TreeIcon name="fit" />
        <span className="st-controls__label">Fit</span>
      </button>
    </div>
  )
}
